if (!customElements.get('product-sticky')) {
  class ProductSticky extends HTMLElement {
    constructor() {
      super();

      this.handleScrollRef = this.handleScroll.bind(this);
    }

    handleScroll() {
      this.classList.toggle(
        'is-visible',
        this.target.getBoundingClientRect().top <= 140,
      );
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.handleScrollRef, {
        passive: true,
      });
    }

    connectedCallback() {
      this.target = document.querySelector('product-selector [name="add"]');
      if (!this.target) return;

      document.addEventListener('scroll', this.handleScrollRef, {
        passive: true,
      });

      this.handleScroll();
    }
  }

  customElements.define('product-sticky', ProductSticky);
}
